<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>For New Orleans</em></p>
<p class="blockquote"><a id="page_vi"></a><em>Let history be a witness that I am a criminal.</em></p>
<p class="attribution"><em>—Osama bin Laden</em></p>
<p class="indent1"><em>Quoted in The 9/11 Commission Report.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2c4b7482